const filters = [
  {
    id: "price",
    label: "Цена",
    type: "range",
    placeholders: ["От", "До"],
  },
  {
    id: "size",
    label: "Размер",
    type: "select",
    options: ["XS", "S", "M", "L"],
  },
  {
    id: "color",
    label: "Цвет",
    type: "select",
    options: ["Оранжевый", "Розовый"],
  },
  {
    id: "category",
    label: "Категория",
    type: "select",
    options: ["Закрита модель", "Новая модель"],
  },
  {
    id: "warehouse",
    label: "Склад",
    type: "select",
    options: ["Основной склад", "Одесса", "Киев"],
  },
  { id: "archived", label: "Архивные", type: "checkbox" },
  { id: "actual", label: "Актуальные", type: "checkbox" },
];

export default filters;
